import React from 'react';
import { FiCheck, FiHeart, FiMail } from 'react-icons/fi';
import styles from '../CourseCatalog.module.css';

const CONTACT_EMAIL = 'admin@faithinsight.org';

// Closing card of the catalog page: where to ask about enrollment, payment or financial assistance.
export default function SupportCard() {
  // The wrapper is the size container: the card switches layout by the room it actually has (the signed-in
  // sidebar narrows the page at wider screens), not by the screen width.
  return (
    <div className={styles.supportWrap}>
      <section className={styles.supportCard} id="financial-support" aria-labelledby="support-heading">
        <span className={styles.supportIcon} aria-hidden="true">
          <FiHeart size={22} />
        </span>
        <h2 id="support-heading" className={styles.supportTitle}>Enrollment &amp; Financial Support</h2>
        <p className={styles.supportCopy}>
          If you require financial assistance or have questions about course enrollment and payment options,
          please do not hesitate to contact us. We are here to help!
        </p>
        <a className={styles.supportButton} href={`mailto:${CONTACT_EMAIL}`}>
          <FiMail size={15} aria-hidden="true" />
          Contact Us
        </a>
      </section>
    </div>
  );
}

// Line under the hero buttons that leads to the card above.
export function FinancialAssistanceNote() {
  const goToSupport = (event) => {
    event.preventDefault();
    const target = document.getElementById('financial-support');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  return (
    <p className={styles.heroNote}>
      <FiCheck size={14} aria-hidden="true" />
      <span>
        Need financial assistance?{' '}
        <a href="#financial-support" className={styles.heroNoteLink} onClick={goToSupport}>We’re here to help</a>
      </span>
    </p>
  );
}
